import styled from '@emotion/styled';

export const Container = styled.div<{
  width?: string;
  height?: string;
  isDisplayMGMRewardsPromoBanner?: boolean;
  flexDirection?: 'row' | 'column';
  gap?: string;
}>`
  display: flex;
  margin: auto;
  align-items: center;

  flex-direction: ${({ flexDirection }) => flexDirection || 'column'};
  justify-content: ${({ isDisplayMGMRewardsPromoBanner }) =>
    isDisplayMGMRewardsPromoBanner ? 'space-between' : 'center'};

  gap: ${({ gap }) => gap || '0px'};

  width: ${({ isDisplayMGMRewardsPromoBanner, width }) =>
    isDisplayMGMRewardsPromoBanner ? '712px' : width || '343px'};

  height: ${({ height }) => height || '540px'};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0px;
    position: static;
    width: 100%;
  }

  > div,
  button {
    align-self: stretch;
  }
`;
